import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";

// Submits an input field without a form
export default class extends Controller {
  submit(event) {
    const formData = new FormData();
    const value = this.element.type === "checkbox" ? this.element.checked : this.element.value;
    formData.append(this.element.name, value);

    const request = new FetchRequest(event.params.method, event.params.path, {
      body: formData,
      responseKind: event.params.responseKind || "turbo-stream",
    });
    request.perform();
  }
}
